import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export function useRole() {

  const {pathname} = useLocation();
  const [role, setRole] = useState();

  const getRole = () => {

    const segments = pathname.split('/');
    setRole(segments[1] ?? null);

  }

  useEffect(() => {
    getRole();
  }, [role]);

  return {role}

}